export const ATTACHMENT_VIEWS = [
  {
    label: 'label.NORMAL',
    value: 'normal'
  },
  {
    label: 'label.COMPACT',
    value: 'compact'
  },
  {
    label: 'label.MINI',
    value: 'mini'
  }
];
